import { DomainName, domains } from "./domains";
import { SiteConfigFactory } from "./factories/siteConfigFactory";
import { SiteInfo } from "./types";

const DEFAULT_SITE_DOMAIN = SiteConfigFactory.create(DomainName.QRCreator);

/**
 * Gets the complete site configuration for a given domain.
 * @param domainName site domain (Ex. "qrcreator.com").
 * @returns The complete SiteInfo object for the matching or default domain.
 */
export const getSiteInfo = (domainName: string): SiteInfo => {
  const formattedDomain = domainName?.split(".").slice(-2).join(".");

  const siteInfo = domains[formattedDomain] || DEFAULT_SITE_DOMAIN;

  return siteInfo;
};
